module.exports = __webpack_public_path__ + "media/images/icons/outlined/trophy-ed60b567b6545924e579331bab398424.svg";